import { GET } from "../../../APiHelper/API"

export const getDeletedTeamsForCupAPI = (cup_id, onSuccess, onError) => {
    GET(`/api/v1/cups/${cup_id}/deleted_teams`, onSuccess, onError)
}